// Small Italian flag — subtle, sharp-edged, scales with text.
import React from "react";

export const ItalyFlag = ({ width = 18, height, className = "", title = "Italia", orientation = "horizontal" }) => {
  const isVertical = orientation === "vertical";
  // Horizontal: 3 wide x 2 tall. Vertical: 2 wide x 3 tall (green at top — hoist side up).
  const vbW = isVertical ? 2 : 3;
  const vbH = isVertical ? 3 : 2;
  const w = isVertical ? width : width;
  const h = height ?? (isVertical ? (width * 3) / 2 : (width * 2) / 3);
  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${vbW} ${vbH}`}
      role="img"
      aria-label={title}
      className={`inline-block align-middle shrink-0 ${className}`}
      preserveAspectRatio="none"
    >
      <title>{title}</title>
      {isVertical ? (
        <>
          <rect width="2" height="1" y="0" fill="#009246" />
          <rect width="2" height="1" y="1" fill="#ffffff" />
          <rect width="2" height="1" y="2" fill="#ce2b37" />
          <rect
            width="2"
            height="3"
            fill="none"
            stroke="rgba(0,0,0,0.08)"
            strokeWidth="0.06"
          />
        </>
      ) : (
        <>
          <rect width="1" height="2" x="0" fill="#009246" />
          <rect width="1" height="2" x="1" fill="#ffffff" />
          <rect width="1" height="2" x="2" fill="#ce2b37" />
          <rect
            width="3"
            height="2"
            fill="none"
            stroke="rgba(0,0,0,0.08)"
            strokeWidth="0.06"
          />
        </>
      )}
    </svg>
  );
};
